export default __webpack_public_path__ + "static/media/IconLogo.5488b4d9.png";